'use strict';

var _encode = require('./encode.filter');

var _decode = require('./decode.filter');

angular.module('bc.AngularUrlEncode', []).filter('bcEncode', _encode.EncodeFilter).filter('bcDecode', _decode.DecodeFilter);


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/